import React from 'react'
import type { ClassNameMap } from '@mui/material'
import type { CloudMarketplace } from '../../types/index'
import aws from '../../common/images/aws.png'
import azure from '../../common/images/azureMarketPlace.png'
import gcp from '../../common/images/gcpMarketPlace.png'

export type MarketplaceIconProps = {
  classes: ClassNameMap
  cloudMarketplace: CloudMarketplace
}

export const MarketplaceIcon = React.memo(
  ({ classes, cloudMarketplace }: MarketplaceIconProps) => {
    switch (cloudMarketplace) {
      case 'AWS':
        return (
          <img
            className={classes.awslogo}
            src={aws}
            alt="aws"
            data-testid="aws-logo"
          />
        )
      case 'AZURE':
        return (
          <img
            className={classes.azurelogo}
            src={azure}
            alt="azure"
            data-testid="azure-logo"
          />
        )
      case 'GCP':
      case 'REDHAT':
        return (
          <img
            className={classes.gcpLogo}
            src={gcp}
            alt={cloudMarketplace.toLowerCase()}
            data-testid={`${cloudMarketplace.toLowerCase()}-logo`}
          />
        )
      default:
        return null
    }
  }
)
